<template lang="pug">
  .crud
    modal-commissions-note(:addNote='addNote')
    modal-import(model="commission" :title="$t('front.import_modal', {model: $t('strings.commission')})")
    .container-fluid
      vm-row.heading(vm-w="12")
        vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=12)
          div
            h2 {{ $t('strings.commissions') }}:
            span {{ $t('strings.description', {attribute: $t('strings.commissions')}) }}
          div(style="display:none;")
            vm-button(type="default" icon="list")
            vm-button(type="default" icon="grid" color="rgba(var(--gray),1)")
      vm-tabs
        vm-tab(vm-label='Comisiones abiertas' @click="flag = false")
          vm-row(vm-w="12")
            vm-col(vm-type="flex" vm-justify="flex-end" vm-lg=12 vm-sm=12)
              div
                vm-tooltip(:text="$t('strings.options')" delay=".5s")
                  vm-dropdown(vm-custom-content vm-trigger-click)
                    vm-button(type="border" icon="more-horizotnal" color="#afbbc6")
                    vm-dropdown-menu
                      vm-dropdown-item.d-flex.justify-content-between(@click="printReport")
                        vm-icon(icon="printer-outline")
                        slot &nbsp;{{ $t('strings.print') }}
          vm-row(vm-w="12")
            vm-col.card(vm-sm=12)
              vm-table(v-model="selected"  max-height="350px" :data="commissions")
                template(slot="header")
                  .d-flex.justify-content-between
                    vm-input(icon="search" size="small" :placeholder="$t('strings.search')" v-model="filters.where.param" @keyup.enter="applyFilter(filters)")
                    div
                      vm-select(v-model="perPage" width="60px")
                        vm-select-item(:key="index" :value="item.value" :text="item.value" v-for="(item,index) in pageItems")
                      vm-select(:placeholder="$t('strings.order_by')" autocomplete v-model="filters.orderBy" @change="applyFilter(filters)" size="small" width="200px")
                        div(v-for="(item,index) in columns")
                          vm-select-item(:key="item + ',asc'" v-if="item !== '' && item !== 'actions'" :value="item + ',asc'" :text="$t('commissions.'+ item) + ', asc'")
                          vm-select-item(:key="item + ',desc'" v-if="item !== '' && item !== 'actions'" :value="item + ',desc'" :text="$t('commissions.'+ item) + ', desc'")
                      vm-tooltip(:text="$t('strings.filters')" delay=".5s")
                        vm-dropdown(ref="dropdown" vm-custom-content vm-trigger-click vm-trigger-outside-click)
                          vm-button(type="default" icon="funnel-outline" size="small")

                          vm-dropdown-menu(class="filters")
                            .heading.d-flex.justify-content-between
                              h4 {{ $t('strings.filters') }}
                              vm-button(type="flat" size="small" @click="clearFilter") {{ $t('strings.clear') }}
                            vm-select.filter(:placeholder="$t('strings.multiple')" multiple autocomplete label="Status" v-model="filters.whereIn.status")
                              vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in status")
                            vm-select.filter(url="users" column="name" :placeholder="$t('strings.multiple')" multiple autocomplete :label="$t('commissions.seller_id')" v-model="filters.whereIn.seller_id" @input-change="autoCompleteFunc")
                              vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in commissionsCatalog.users")
                            vm-date-picker.filter(type="daterange" :label="$t('commissions.sale_liquidation_date')" :placeholder="$t('strings.select_date')" @on-change="handleChange" :value="filters.betweenDates.sale_liquidation_date")
                            //- Add filters
                                Agrega los filtros que prefieras por ejemplo:
                                vm-select.filter(url="customers" column="tradename" :placeholder="$t('strings.multiple')" multiple autocomplete :label="$t('sales.customer_id')" v-model="filters.whereIn.customer_id" @input-change="autoCompleteFunc")
                                  vm-select-item(:key="index" :value="item.id" :text="item.tradename" v-for="(item,index) in commissionsCatalog.customers")

                                NOTA: (agregar clase .filter)
                            .filter.d-flex
                              vm-button(@click="applyFilter(filters)") {{ $t('strings.apply') }}
                template(slot="thead")
                  vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('commissions.' + column) }}
                template(slot-scope="{data}")
                  vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                    vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                      slot(v-if="column != 'customer_id' && column != 'seller_id' && column != 'status' && column != 'sale_amount' && column != 'direct_cost' && column != 'currency_id' && column != 'sale_amount_mxn' && column != 'direct_cost_mxn' && column != 'imports' && column != 'shippings' && column != 'other_expenses' && column != 'commissionable_amount' && column != 'commission' && column != 'commissioned_amount' && column != 'sale_liquidation_date' && column != 'sale_folio'") {{ data[indextr][column] }}
                      slot(v-if="column == 'sale_amount' || column == 'direct_cost' || column == 'sale_amount_mxn' || column == 'direct_cost_mxn' || column == 'imports' || column == 'shippings' || column == 'other_expenses' || column == 'commissionable_amount' || column == 'commissioned_amount'")  {{ data[indextr][column] | currency }}
                      slot(v-if="column == 'order_customer'") {{data[indextr]['quotation']['order_customer'] }}
                      slot(v-if="column == 'customer_id'") {{ data[indextr]['customer_name'] }}
                      slot(v-if="column == 'seller_id'") {{ data[indextr]['seller_name'] }}
                      slot(v-if="column == 'currency_id'") {{ data[indextr]['currency_code'] }}
                      slot(v-if="column == 'sale_liquidation_date'") {{ data[indextr]['sale_liquidation_date'] | moment('DD-MMMM-YYYY') }}
                      slot(v-if="column == 'sale_folio'") {{ data[indextr]['sale']['folio'] }}
                      .input__wrapper(v-if="column == 'commission'")
                        vm-input(v-model="data[indextr].commission" :disabled="data[indextr].status !== 'initial' && data[indextr].status !== 'rejected' || !$auth.check('Admin')")
                      vm-chip(v-if="column == 'status'" :color="colorStatus(data[indextr][column])") {{ nameStatus(data[indextr][column]) }}
                      slot(v-if="column == 'calculed_commission'") {{ calculedCommission(data[indextr]) | currency }}
                      slot(v-if="column == 'actions'")
                        vm-button(v-if="data[indextr].status == 'initial' && $auth.check('Admin') || data[indextr].status == 'rejected' && $auth.check('Admin')" vm-trigger-click type="flat" icon="external-link-outline" color="primary" :title="$t('strings.propose')" @click="setActionCommission(data[indextr], tr, 'propouse')")
                        vm-button(v-if="data[indextr].status == 'propoused' && !$auth.check('Admin')" vm-trigger-click type="flat" icon="checkmark-circle-2-outline" color="success" :title="$t('strings.accept')" @click="setActionCommission(data[indextr], tr, 'accept')")
                        vm-button(v-if="data[indextr].status == 'propoused' && !$auth.check('Admin')" vm-trigger-click type="flat" icon="close-circle-outline" color="danger" :title="$t('strings.reject')" @click="setActionCommission(data[indextr], tr, 'reject')")
                        vm-button(v-if="data[indextr].status == 'accepted' && $auth.check('Admin')" vm-trigger-click type="flat" icon="archive-outline" color="gray" :title="$t('strings.close')" @click="setActionCommission(data[indextr], tr, 'close')")
                        vm-button(v-if="data[indextr].status == 'rejected' && $auth.check('Admin') && data[indextr].note" vm-trigger-click type="flat" icon="eye-outline" color="primary" :title="$t('strings.see_note')" @click="seeNote(data[indextr], tr)")
              vm-pagination(:total="pagination.totalPages" v-model="currentPage" goto)
              transition(name="enter")
                .total-records(v-if="total>0") Total: {{ total | currency }}
              vm-row(vm-align="center" vm-type="flex" vm-justify="center" vm-w="12" class="gutters" style="padding:10px;")
                vm-col(vm-align="center" vm-type="flex" vm-justify="center" vm-w="9" class="gutters")
                vm-col(v-if="!$auth.check('Admin') && accept_all_flag" vm-align="center" vm-type="flex" vm-justify="center" vm-w="1.5" class="gutters")
                  vm-button(style="width:90%; padding:10px !important;" color="success" @click="acceptAllConfirm(commissions)") Aceptar todas
                vm-col(v-if="!$auth.check('Admin') && reject_all_flag" vm-align="center" vm-type="flex" vm-justify="center" vm-w="1.5" class="gutters")
                  vm-button(style="width:90%; padding:10px !important;" color="danger" @click="rejectAllConfirm(commissions)") Rechazar todas
                vm-col(v-if="$auth.check('Admin') && propouse_all_flag" vm-align="center" vm-type="flex" vm-justify="center" vm-w="1.5" class="gutters")
                  vm-button(style="width:90%; padding:10px !important;" color="primary" @click="propouseAllConfirm(commissions)") Proponer todas
                vm-col(v-if="$auth.check('Admin') && close_all_flag" vm-align="center" vm-type="flex" vm-justify="center" vm-w="1.5" class="gutters")
                  vm-button(style="width:90%; padding:10px !important;" color="grey" @click="closeAllConfirm(commissions)") Cerrar todas
            .floating_total_amount
              span Total Pagado
              span {{ totalPaid | currency }}
            .floating_total_commission
              span Total Comisiones
              span {{ commissionsTotal | currency }}
        vm-tab(vm-label='Comisiones cerradas' @click="flag = false")
          vm-row(vm-w="12" style="margin-bottom:1rem;")
            vm-col(vm-type="flex" vm-justify="center" vm-lg=4 vm-sm=4)
              vm-input.filter(:label="$t('strings.search')" icon="search" :placeholder="$t('strings.search')" v-model="filtersClosed.where.param" @keyup.enter="applyFilterClosed(filtersClosed)")
              vm-select.filter(url="users" column="name" :placeholder="$t('strings.multiple')" autocomplete :label="$t('commissions.seller_id')" v-model="filtersClosed.where.seller_id" @input-change="autoCompleteFunc")
                vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in commissionsCatalog.users")
            vm-col(vm-type="flex" vm-justify="center" vm-lg=2 vm-sm=2)
              vm-date-picker.filter(size='large' type="daterange" :label="$t('commissions.sale_liquidation_date')" :placeholder="$t('strings.select_date')" @on-change="handleChangeClosed" :value="filtersClosed.betweenDates.sale_liquidation_date")
            vm-col(vm-lg=2 vm-sm=2)
              vm-button(size='large' style="margin-top:1.5rem;" @click="applyFilterClosed(filtersClosed)") {{ $t('strings.apply') }}
            vm-col(vm-type="flex" vm-justify="flex-end" vm-lg=4 vm-sm=4)
              vm-button(size='large' style="margin-top:1.5rem;" icon="printer-outline" color="primary" @click="printReportClosed") Imprimir
          vm-row(vm-w="12")
            vm-col.card(vm-sm=12 style="min-height:500px;")
              vm-table(v-model="selected" max-height="350px" :data="commissionsClosed")
                template(slot="header")
                template(slot="thead")
                  vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columnsClosed") {{ $t('commissions.' + column) }}
                template(slot-scope="{data}")
                  vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                    vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columnsClosed")
                      slot(v-if="column != 'customer_id' && column != 'seller_id' && column != 'status' && column != 'sale_amount' && column != 'direct_cost' && column != 'currency_id' && column != 'sale_amount_mxn' && column != 'direct_cost_mxn' && column != 'imports' && column != 'shippings' && column != 'other_expenses' && column != 'commissionable_amount' && column != 'commission' && column != 'commissioned_amount' && column != 'sale_liquidation_date'") {{ data[indextr][column] }}
                      slot(v-if="column == 'sale_amount' || column == 'direct_cost' || column == 'sale_amount_mxn' || column == 'direct_cost_mxn' || column == 'imports' || column == 'shippings' || column == 'other_expenses' || column == 'commissionable_amount' || column == 'commissioned_amount'")  {{ data[indextr][column] | currency }}
                      slot(v-if="column == 'order_customer'") {{data[indextr]['quotation']['order_customer'] }}
                      slot(v-if="column == 'customer_id'") {{ data[indextr]['customer_name'] }}
                      slot(v-if="column == 'seller_id'") {{ data[indextr]['seller_name'] }}
                      slot(v-if="column == 'currency_id'") {{ data[indextr]['currency_code'] }}
                      slot(v-if="column == 'commission'") {{ data[indextr]['commission'] }}%
                      slot(v-if="column == 'sale_liquidation_date'") {{ data[indextr]['sale_liquidation_date'] | moment('DD-MMMM-YYYY') }}
              vm-pagination(:total="paginationClosed.totalPages" v-model="currentPageClosed" goto)
              transition(name="enter")
                .total-records(v-if="total>0") Total: {{ total | currency }}
            .floating_total_amount
              span Total Pagado
              span {{ totalPaidClosed | currency }}
            .floating_total_commission
              span Total Comisiones
              span {{ commissionsTotalClosed | currency }}
        vm-tab(vm-label='Graficas' @click="flag = false" v-if="$auth.check('Admin')")
          vm-row(vm-w="12")
            vm-col(vm-lg=12)
              .card.score-card
                h5.filter Comisiones por mes
                vm-date-picker.filter(type="year" :placeholder="$t('strings.select_date')" @on-change="handleComYear" :value="grapicYear")
                apexchart(height="350" type="bar" :options="optionsYear" :series="commissions_year")
          vm-row(vm-w="12")
            vm-col(vm-lg=6)
              .card.score-card
                h5.filter Comisiones por vendedor
                vm-date-picker.filter(type="month" :placeholder="$t('strings.select_date')" @on-change="handleCommissions" :value="commissionsMonth")
                apexchart(height="350" type="bar" :options="optionsDinamic" :series="commissions_seller")
            vm-col(vm-lg=6)
              .card.score-card
                h5.filter Ventas por mes
                vm-date-picker.filter(type="month" :placeholder="$t('strings.select_date')" @on-change="handleSales" :value="salesMonth")
                apexchart(height="350" type="bar" :options="optionsDinamic" :series="sales_seller")
          vm-row(vm-w="12")
            vm-col(vm-lg=6)
              .card.score-card
                h5.filter Top ventas por cliente
                vm-row(vm-w="12")
                  vm-col(vm-lg=6)
                    vm-select.filter(:placeholder="$t('commissions.seller_id')" v-model="customersSeller")
                      vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in commissionsCatalog.users")
                  vm-col(vm-lg=6)
                    vm-date-picker.filter(type="year" :placeholder="$t('strings.select_date')" @on-change="handleTopCliYear" :value="topCliYear")
                apexchart(height="350" type="bar" :options="optionsNoLabel" :series="top_sales_customer")
            vm-col(vm-lg=6)
              .card.score-card
                h5.filter Top ventas por producto
                vm-row(vm-w="12")
                  vm-col(vm-lg=6)
                    vm-select.filter(:placeholder="$t('commissions.seller_id')" v-model="productsSeller")
                      vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in commissionsCatalog.users")
                  vm-col(vm-lg=6)
                    vm-date-picker.filter(type="year" :placeholder="$t('strings.select_date')" @on-change="handleTopProYear" :value="topProYear")
                apexchart(height="350" type="bar" :options="optionsNoLabel" :series="top_sales_product")
</template>

<script>
import ModalCommissionsNote from '@/components/modals/ModalCommissionsNote.vue'
import ModalImport from '@/components/modals/ModalImport.vue'
import parseVuexObject from '@/utils/parseVuexObject'
import { createNamespacedHelpers } from 'vuex'
import Vue from 'vue'
import moment from 'moment'
const { mapGetters, mapActions } = createNamespacedHelpers('Commissions')

export default {
  name: 'Commissions',
  components: {
    ModalCommissionsNote,
    ModalImport
  },
  data: () => ({
    currentPage: 1,
    currentPageClosed: 1,
    perPage: 20,
    isModalAdd: true,
    grapicYear: moment().format('YYYY'),
    topCliYear: moment().format('YYYY'),
    topProYear: moment().format('YYYY'),
    commissionsMonth: moment().subtract(1, 'months').endOf('month').format('YYYY-MM'),
    salesMonth: moment().subtract(1, 'months').endOf('month').format('YYYY-MM'),
    customersSeller: 1,
    productsSeller: 1,
    addNote: {},
    selected: [],
    enabledDelete: false,
    optionsYear: {
      chart: {
        height: 350,
        type: 'bar'
      },
      plotOptions: {
        bar: {
          borderRadius: 10,
          dataLabels: {
            position: 'top' // top, center, bottom
          },
          columnWidth: '45%',
          distributed: true
        }
      },
      dataLabels: {
        enabled: false,
        formatter: (val) => {
          return Vue.filter('currency')(val)
        },
        offsetY: -20,
        style: {
          fontSize: '12px',
          colors: ['#0f5377', '#026481', '#347c76', '#27a398']
        }
      },
      legend: {
        show: false
      },
      colors: ['#0f5377', '#026481', '#347c76', '#27a398'],
      xaxis: {
        categories: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
        position: 'bottom',
        type: 'string',
        axisBorder: {
          show: true
        }
      },
      yaxis: {
        axisBorder: {
          show: true
        },
        axisTicks: {
          show: true
        },
        labels: {
          show: true,
          formatter: (val) => {
            return Vue.filter('currency')(val)
          }
        }
      }
    },
    optionsDinamic: {
      chart: {
        height: 350,
        type: 'bar'
      },
      plotOptions: {
        bar: {
          borderRadius: 10,
          dataLabels: {
            position: 'top' // top, center, bottom
          },
          columnWidth: '45%',
          distributed: true
        }
      },
      dataLabels: {
        enabled: false,
        formatter: (val) => {
          return Vue.filter('currency')(val)
        },
        offsetY: -20,
        style: {
          fontSize: '12px',
          colors: ['#0f5377', '#026481', '#347c76', '#27a398']
        }
      },
      legend: {
        show: false
      },
      colors: ['#0f5377', '#026481', '#347c76', '#27a398'],
      xaxis: {
        position: 'bottom',
        type: 'string',
        axisBorder: {
          show: true
        }
      },
      yaxis: {
        axisBorder: {
          show: true
        },
        axisTicks: {
          show: true
        },
        labels: {
          show: true,
          formatter: (val) => {
            return Vue.filter('currency')(val)
          }
        }
      }
    },
    optionsNoLabel: {
      chart: {
        height: 350,
        type: 'bar'
      },
      plotOptions: {
        bar: {
          borderRadius: 10,
          dataLabels: {
            position: 'top' // top, center, bottom
          },
          columnWidth: '45%',
          distributed: true
        }
      },
      dataLabels: {
        enabled: false,
        formatter: (val) => {
          return Vue.filter('currency')(val)
        },
        offsetY: -20,
        style: {
          fontSize: '12px',
          colors: ['#0f5377', '#026481', '#347c76', '#27a398']
        }
      },
      legend: {
        show: false
      },
      colors: ['#0f5377', '#026481', '#347c76', '#27a398'],
      xaxis: {
        position: 'bottom',
        type: 'string',
        axisBorder: {
          show: true
        },
        labels: {
          show: false
        }
      },
      yaxis: {
        axisBorder: {
          show: true
        },
        axisTicks: {
          show: true
        },
        labels: {
          show: true,
          formatter: (val) => {
            return Vue.filter('currency')(val)
          }
        }
      }
    },
    columns: [
      // Agrega las columnas a mostrar
      'sale_id',
      'quotation_folio',
      'order_customer',
      'customer_id',
      'seller_id',
      'sale_amount',
      'direct_cost',
      'currency_id',
      'direct_cost_mxn',
      'imports',
      'shippings',
      'other_expenses',
      'sale_amount_mxn',
      'commissionable_amount',
      'commission',
      'calculed_commission',
      'sale_liquidation_date',
      'status',
      'actions'
    ],
    columnsClosed: [
      // Agrega las columnas a mostrar
      'sale_id',
      'quotation_folio',
      'order_customer',
      'customer_id',
      'seller_id',
      'sale_amount',
      'direct_cost',
      'currency_id',
      'direct_cost_mxn',
      'imports',
      'shippings',
      'other_expenses',
      'sale_amount_mxn',
      'commissionable_amount',
      'commission',
      'commissioned_amount',
      'sale_liquidation_date'
    ],
    status: [
      // Agregar los estatus si maneja
      {
        text: 'Inicial',
        value: 'initial',
        color: 'gray'
      },
      {
        text: 'Propuesto',
        value: 'propoused',
        color: 'primary'
      },
      {
        text: 'Aceptado',
        value: 'accepted',
        color: 'success'
      },
      {
        text: 'Rechazado',
        value: 'rejected',
        color: 'danger'
      },
      {
        text: 'Cerrado',
        value: 'closed',
        color: 'dark'
      }
    ],
    pageItems: [
      {
        value: 20
      },
      {
        value: 50
      },
      {
        value: 100
      }
    ],
    filters: {
      // Nota: Estos campos se parsearan en el v-model de los filtros. Ver linea 60
      where: {
        // Agregar las columnas que se filtraran en el buscador
        sale_id: '',
        quotation: {
          order_customer: '',
          folio: ''
        },
        param: ''
      },
      whereIn: {
        // Agrega las columnas que se filtraran con mas de una opcion ejemplo: status: []
        status: [],
        seller_id: []
      },
      whereBetween: {
        // Agrega las columnas que se filtraran entre paramentros ejemplo: priece: []
      },
      betweenDates: {
        // Agrega las columnas que se filtraran entre fechas: created_at: []
        sale_liquidation_date: []
      },
      includes: '', // Agrega las relaciones separados con coma y sin espacio
      orderBy: ''
    },
    filtersClosed: {
      // Nota: Estos campos se parsearan en el v-model de los filtros. Ver linea 60
      where: {
        // Agregar las columnas que se filtraran en el buscador
        seller_id: '',
        param: ''
      },
      whereIn: {
        // Agrega las columnas que se filtraran con mas de una opcion ejemplo: status: []
      },
      whereBetween: {
        // Agrega las columnas que se filtraran entre paramentros ejemplo: priece: []
      },
      betweenDates: {
        // Agrega las columnas que se filtraran entre fechas: created_at: []
        sale_liquidation_date: []
      },
      includes: '', // Agrega las relaciones separados con coma y sin espacio
      orderBy: ''
    }
  }),
  computed: {
    ...mapGetters([
      'commissions',
      'commissionsCatalog',
      'pagination',
      'filterParams',
      'commissionsClosed',
      'commissionsClosedCatalog',
      'paginationClosed',
      'filterParamsClosed',
      'commissionsYear',
      'commissionsSeller',
      'salesSeller',
      'topSalesCustomer',
      'topSalesProduct',
      'commissionsTotal',
      'totalPaid',
      'commissionsTotalClosed',
      'totalPaidClosed'
    ]),
    commissions_year () {
      let orders = [{
        data: this.commissionsYear
      }]
      return orders
    },
    commissions_seller () {
      let orders = [{
        data: this.commissionsSeller
      }]
      return orders
    },
    sales_seller () {
      let orders = [{
        data: this.salesSeller
      }]
      return orders
    },
    top_sales_customer () {
      let orders = [{
        data: this.topSalesCustomer
      }]
      return orders
    },
    top_sales_product () {
      let orders = [{
        data: this.topSalesProduct
      }]
      return orders
    },
    accept_all_flag () {
      let count = 0
      this.commissions.forEach(c => {
        if (c.status === 'propoused') {
          count = count + 1
        }
      })
      return count > 1
    },
    reject_all_flag () {
      let count = 0
      this.commissions.forEach(c => {
        if (c.status === 'propoused') {
          count = count + 1
        }
      })
      return count > 1
    },
    propouse_all_flag () {
      let count = 0
      this.commissions.forEach(c => {
        if (c.status === 'initial') {
          count = count + 1
        }
      })
      return count > 1
    },
    close_all_flag () {
      let count = 0
      this.commissions.forEach(c => {
        if (c.status === 'accepted') {
          count = count + 1
        }
      })
      return count > 1
    }
  },
  watch: {
    currentPage (currentPage) {
      this.getCommissions(currentPage, this.perPage)
    },
    perPage (perPage) {
      this.getCommissions(this.currentPage, perPage)
    },
    filterParams (filter) {
      filter.length === 0 && (this.filters = parseVuexObject(this.filtersClear))
      this.currentPage = 1
      this.selected = []
      this.perPage = 20
      this.getCommissions(this.currentPage, this.perPage)
    },
    currentPageClosed (currentPage) {
      this.getCommissionsClosed(currentPage, 20)
    },
    filterParamsClosed (filter) {
      filter.length === 0 && (this.filtersClosed = parseVuexObject(this.filtersClosedClear))
      this.currentPage = 1
      this.selected = []
      this.perPage = 20
      this.getCommissionsClosed(this.currentPage, 20)
    },
    selected (selected) {
      this.enabledDelete = selected.length > 0
    },
    customersSeller (id) {
      this.loadTopSalesCustomer({ id: id, year: this.topCliYear })
    },
    productsSeller (id) {
      this.loadTopSalesProduct({ id: id, year: this.topCliYear })
    }
  },
  async created () {
    this.filtersClear = parseVuexObject(this.filters)
    this.filtersClosedClear = parseVuexObject(this.filtersClosed)
    this.filters.betweenDates.sale_liquidation_date = this.dateRange()
    await this.getCommissions(this.currentPage, 20)
    await this.applyFilter(this.filters)
    await this.getCommissionsClosed(this.currentPage, 20)
    this.getCatalog()
    await this.loadCommissionsYear({ year: this.grapicYear })
    await this.loadCommissionsSeller({ month: moment(this.commissionsMonth).format('M'), year: moment(this.commissionsMonth).format('YYYY') })
    await this.loadSalesSeller({ month: moment(this.salesMonth).format('M'), year: moment(this.salesMonth).format('YYYY') })
    await this.loadTopSalesCustomer({ id: this.customersSeller, year: this.topCliYear })
    await this.loadTopSalesProduct({ id: this.productsSeller, year: this.topProYear })
  },
  methods: {
    ...mapActions([
      'loadCommissions',
      'loadCommissionsClosed',
      'loadCatalog',
      'actionCommission',
      'setModalImportVisible',
      'setModalVisible',
      'setModalNoteVisible',
      'printReport',
      'printReportClosed',
      'applyFilter',
      'clearFilter',
      'applyFilterClosed',
      'clearFilterClosed',
      'acceptCommissions',
      'rejectCommissions',
      'propouseCommissions',
      'closeCommissions',
      'loadCommissionsYear',
      'loadCommissionsSeller',
      'loadSalesSeller',
      'loadTopSalesCustomer',
      'loadTopSalesProduct'
    ]),
    colorStatus (code) {
      return this.status.find(e => e.value === code)['color']
    },
    nameStatus (code) {
      return this.status.find(e => e.value === code)['text']
    },
    dateRange () {
      const date = []
      const lastmonthfirstdate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD')
      const lastmonthlastdate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD')
      date.push(lastmonthfirstdate)
      date.push(lastmonthlastdate)
      return date
    },
    addCommission () {
      this.isModalAdd = true
      this.setModalVisible(true)
      this.newRecord = {}
    },
    editCommission (commission, index) {
      this.isModalAdd = false
      this.setModalVisible(true)
      this.newRecord = { ...commission }
    },
    async setActionCommission (record, index, action) {
      switch (action) {
        case 'accept':
          await this.actionCommission({ id: record.id, action: action, commissioned_amount: this.calculedCommission(record) }).then(() => {
            this.loadCommissions({ page: this.currentPage, perPage: this.perPage })
          })
          break
        case 'reject':
          this.setModalNoteVisible(true)
          this.addNote = {
            id: record.id,
            isAll: false,
            action: action,
            page: this.currentPage,
            perPage: this.perPage,
            note: ''
          }
          break
        default:
          await this.actionCommission({ id: record.id, action: action, commission: record.commission }).then(() => {
            this.loadCommissions({ page: this.currentPage, perPage: this.perPage })
            this.loadCommissionsClosed({ page: this.currentPageClosed, perPage: this.perPage })
          })
          break
      }
    },
    async getCommissions (page, perPage) {
      let t = this
      this.loadCommissions({ page: page, perPage: perPage }).then(data => t.getProps(t.$route.params.id))
    },
    async getCommissionsClosed (page, perPage) {
      let t = this
      this.loadCommissionsClosed({ page: page, perPage: perPage }).then(data => t.getProps(t.$route.params.id))
    },
    getProps (index) {
      let commission = this.commissions.filter(commission => commission.id === parseInt(index))[0]
      commission && this.editCommission(commission, index)
    },
    async getCatalog () {
      Object.keys(this.commissionsCatalog).forEach(e => this.loadCatalog({ url: e, filter: '' }))
    },
    autoCompleteFunc (value) {
      let payload = {}
      let column = value.target.parentElement.parentElement.getAttribute('column')
      let param = value.srcElement.value
      payload.url = value.target.parentElement.parentElement.getAttribute('url')
      payload.filter = `?${column}=*${param}*&order_by=${column},asc`
      this.loadCatalog(payload)
    },
    handleChange (date) {
      this.filters.betweenDates.sale_liquidation_date = date
    },
    handleChangeClosed (date) {
      this.filtersClosed.betweenDates.sale_liquidation_date = date
    },
    calculedCommission (data) {
      return data.commissionable_amount * (data.commission / 100)
    },
    totalCommission (data) {
      return data.reduce((prev, cur) => prev + parseFloat(cur.commissionable_amount * (cur.commission / 100)), 0).toFixed(2)
    },
    totalCommissioned (data) {
      return data.reduce((prev, cur) => prev + parseFloat(cur.commissioned_amount), 0).toFixed(2)
    },
    total (data) {
      return data.reduce((prev, cur) => prev + parseFloat(cur.sale_amount_mxn), 0).toFixed(2)
    },
    async acceptAllConfirm (data) {
      let t = this
      let array = []
      data.map(row => {
        array.push({ id: row.id, commissioned_amount: this.calculedCommission(row) })
      })
      this.auxAccept = () => {
        t.acceptCommissions({ data: array }).then(() => {
          this.loadCommissions({ page: this.currentPage, perPage: this.perPage })
        })
      }
      this.$vm.dialog({
        color: 'success',
        title: this.$t('front.accept_modal'),
        text: this.$t('front.accept_confirmation'),
        accept: this.auxAccept
      })
    },
    async rejectAllConfirm (data) {
      let ids = []
      data.map(row => {
        ids.push(row.id)
      })
      this.setModalNoteVisible(true)
      this.addNote = {
        id: ids,
        isAll: true,
        action: 'reject',
        page: this.currentPage,
        perPage: this.perPage,
        note: ''
      }
    },
    async propouseAllConfirm (data) {
      let t = this
      let array = []
      data.map(row => {
        array.push({ id: row.id, commission: row.commission })
      })
      this.auxPropuse = () => {
        t.propouseCommissions({ data: array }).then(() => {
          this.loadCommissions({ page: this.currentPage, perPage: this.perPage })
        })
      }
      this.$vm.dialog({
        color: 'primary',
        title: this.$t('front.propouse_modal'),
        text: this.$t('front.propouse_confirmation'),
        accept: this.auxPropuse
      })
    },
    async closeAllConfirm (data) {
      let t = this
      let ids = []
      data.map(row => {
        ids.push(row.id)
      })
      this.auxPropuse = () => {
        t.closeCommissions(ids).then(() => {
          this.loadCommissions({ page: this.currentPage, perPage: this.perPage })
          this.loadCommissionsClosed({ page: this.currentPageClosed, perPage: this.perPageClosed })
        })
      }
      this.$vm.dialog({
        color: 'grey',
        title: this.$t('front.close_modal'),
        text: this.$t('front.close_confirmation'),
        accept: this.auxPropuse
      })
    },
    async handleComYear (date) {
      this.grapicYear = date
      await this.loadCommissionsYear({ year: this.grapicYear })
    },
    async handleCommissions (date) {
      this.commissionsMonth = date
      await this.loadCommissionsSeller({ month: moment(this.commissionsMonth).format('M'), year: moment(this.commissionsMonth).format('YYYY') })
    },
    async handleSales (date) {
      this.salesMonth = date
      await this.loadSalesSeller({ month: moment(this.salesMonth).format('M'), year: moment(this.salesMonth).format('YYYY') })
    },
    async handleTopCliYear (date) {
      this.topCliYear = date
      await this.loadTopSalesCustomer({ id: this.customersSeller, year: moment(this.topCliYear).format('YYYY') })
    },
    async handleTopProYear (date) {
      this.topProYear = date
      await this.loadTopSalesProduct({ id: this.productsSeller, year: moment(this.topProYear).format('YYYY') })
    },
    seeNote (record, index) {
      this.$vm.dialog({
        color: 'primary',
        title: 'Motivo de rechazo',
        text: 'Nota:' + record.note
      })
    }
  }
}
</script>

<style lang="scss">
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.con-vm-tooltip {
  display: inline-block;
  float: left;
  position: relative;
}
.vm-table--header {
  padding: 10px;
  span {
    width: 100%;
    .justify-content-between {
      div:last-child {
        .vm-button {
          margin: 0 3px;
        }
        .vm-con-dropdown {
          float: left;
        }
        .con-select {
          display: inline-block;
          input {
            height: 32px;
          }
        }
      }
    }
  }
}

@media screen and (min-width: 992px) {
.floating_total_amount {
    display: flex;
    justify-content: space-between;
    position: fixed;
    top: 20px;
    left: 20px;
    background-color: #0082aa;
    padding: 10px;
    z-index: 20000;
    border-radius: 0.5em;
    span {
      color: #fff;
      padding: 10px;
      &:last-child {
        font-weight: bold;
      }
    }
  }
.floating_total_commission {
    display: flex;
    justify-content: space-between;
    position: fixed;
    top: 20px;
    left: 20px;
    background-color: #0082aa;
    padding: 10px;
    z-index: 20000;
    border-radius: 0.5em;
    span {
      color: #fff;
      padding: 10px;
      &:last-child {
        font-weight: bold;
      }
    }
  }
}
.floating_total_amount {
  top: 14%;
  left: calc(30%);
}
.floating_total_commission {
  top: 14%;
  left: calc(45%);
}
.score-card {
  margin: 5px;
}
h5 {
  font-weight: 100;
  font-size: 21px;
}
.filter {
  padding: 5px 10px;
  width: 100%;
}
.filter50 {
  padding: 5px 10px;
  width: 50% !important;
}
</style>
